import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import Select from 'react-select'
import { InputLabel } from "@mui/material";
import companylogo from "../../assets/company.png"

const ItemsReportPage = () => {
  const [items, setItems] = useState([]);
  const [vendorFilter, setVendorFilter] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [vendors, setVendors] = useState();
  const [category, setCategory] = useState(null)
  const [categoryData, setCategoryData] = useState(null)

  const componentRef = React.createRef();

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`
        );
        const responseData = await response.json();
        if (responseData) {
          const data = responseData.itemservice.filter((item)=>item.type==="Item")
          setItems(data);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    const fetchVendors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
        const responseData = await response.json();
        if (responseData) {
          const options = responseData.vendor.map(vendor => ({
            value: vendor.vendortitle,
            label: vendor.vendortitle
          }));
          setVendors(options);
        }

         

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    // fetch category

    const fetchCategory = async () => {
      try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
          const responseData = await response.json();
          if (responseData) {
              const temp = responseData.categories?.map((cat)=>
                  ({value:cat.id, label:`${cat.categoryname} ID: ${cat.id}`})
              )
              setCategoryData(temp)
          }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  }
  fetchCategory();

    fetchVendors();
    fetchItems();
  }, []);

  useEffect(() => {

    let filteredData = items
    if (!vendorFilter) {
      setFilteredItems(items);
    } else {
      filteredData = filteredData.filter(item => item.vendor_name === vendorFilter.value);
      setFilteredItems(filteredData);
    }

    if(category) {
      filteredData = filteredData.filter(item => item.categoryId == category.value);
      setFilteredItems(filteredData);
    }
  }, [vendorFilter, items, category]);

  return (
    <>
      <StickyTitle no_button={true} title="Inventory Reports" />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
          <div className='text-2xl ml-2 font-bold font-poppins'>Inventory Items Reports</div>
        </div>

        <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
          <section>
            <div className="bg-white p-5 rounded shadow">
              <div className="flex flex-col justify-center">

              <InputLabel>Filter Vendor</InputLabel>
                <Select
                  value={vendorFilter}
                  onChange={(selectedOption) => setVendorFilter(selectedOption)}
                  options={vendors}
                  isClearable={true}
                />

              <InputLabel>Filter Category</InputLabel>
                    <Select
                        value={category}
                        onChange={(selectedOption) => setCategory(selectedOption)}
                        options = {categoryData}
                        isClearable={true}
                    />                                                

              </div>
            </div>
          </section>

          <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
            <ReactToPrint
              trigger={() => (
                <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                  Print / Download
                </button>
              )}
              content={() => componentRef.current}
            />
            <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
              <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                  <div>

                      <img  src={companylogo} alt="logo" />
                  </div>
              </div>
              <article className=" py-2 text-center text-base text-black border-t border-black uppercase w-full font-bold">
                  <p>Inventory Stock Report</p>
              </article>
              <table width="100%" className="mb-10">
                <thead>
                  <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                    <td className="font-bold">Item ID</td>
                    <td className="font-bold">Item Name</td>
                    <td className="font-bold">Current Stock</td>
                    <td className="font-bold">Vendor Name</td>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems && filteredItems?.map((item) => (
                    <tr className=" text-center h-10" key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.itemservice}</td>
                      <td>{item.currentstock}</td>
                      <td>{item.vendor_name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default ItemsReportPage;